var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"fields":_vm.stageAverageFields,"items":_vm.stageAverages,"small":"","striped":"","bordered":""}}),_c('bar-chart',{attrs:{"chart-data":_vm.stageAverageData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }